import React, { memo } from "react";
import styles from "./textArea.module.scss";
import CustomLabel from '../CustomLabel';

const ListItem = ({ className, onChange, value, rows, cols, placeholder, readOnly, label }) => (
    <div className={`${className} ${styles.inputContent} ${label && styles.column}`}>
        {label && <CustomLabel className={styles.label}> {label}</CustomLabel>}
        <textarea
            value={value}
            cols={cols}
            rows={rows}
            onChange={onChange}
            className={styles.textarea}
            placeholder={placeholder}
            readOnly={readOnly}
        />
    </div>
);

export default memo(ListItem);
